import { useState } from 'react';

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What are the different types of blinds available?",
      answer: "We offer a variety of blinds including Venetian, Roman, Roller, Vertical, and Pleated blinds."
    },
    {
      question: "How do I measure my windows for blinds?",
      answer: "To measure for blinds, measure the width and height of the window. Be sure to measure at three different points to ensure accuracy."
    },
    {
      question: "Can I install blinds myself?",
      answer: "Yes! Our blinds come with easy-to-follow instructions, but professional installation services are available upon request."
    },
    {
      question: "Are your blinds customizable?",
      answer: "Absolutely! We offer various colors, materials, and sizes to suit your preferences."
    },
    {
      question: "How do I clean my blinds?",
      answer: "You can clean most blinds with a damp cloth or use a vacuum with a brush attachment. Always check the manufacturer's care instructions."
    },
  ];

  return (
    <section className="bg-gray-100  font-playfair py-20 px-6 lg:px-20 2xl:px-80 items-center">
      <h2 className="text-center text-3xl md:text-5xl font-bold text-gray-800 mb-12">
        Frequently Asked Questions
      </h2>

      <div className="space-y-10">
        {faqs.map((faq, index) => (
          <div key={index} className="border-t  items-center border-gray-300 py-4">
            <div
              onClick={() => toggleAnswer(index)}
              className="flex justify-between items-center cursor-pointer"
            >
              <h3 className=" text-xl md:text-2xl font-semibold">{faq.question}</h3>
              <span className="text-2xl font-bold">
                {activeIndex === index ? '-' : '+'}
              </span>
            </div>

            {activeIndex === index && (
              <p className="mt-2 md:text-xl text-gray-700">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
